var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import SelectDropdown from "../../../../../../shared-library/components/selectdropdown";
import { FileUploadSection } from "@frameworks/web/components/fileupload/fileUploadSection";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import InputField from "@frameworks/web/components/generic/inputField";
import { emailRegex, pan, phoneNo } from "@frameworks/web/utils/regex";
import di from "@frameworks/salesjourney/components/Features/ClientDetails/di/serviceLocator";
var defaultLoaDetails = {
    relative_NAME: "",
    relation: "",
    panno: "",
    email: "",
    fileName: "",
    loaFiles: "",
    eqbse: "",
    eqnse: "",
    eqmsei: "",
    fobse: "",
    fonse: "",
    fomsei: "",
    currencybse: "",
    currencynse: "",
    currencymsei: "",
    mobileNo: "",
};
var LoaFormPop = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    var _y = __read(React.useState([]), 2), relationshipList = _y[0], setRelationshipList = _y[1];
    var _z = __read(useState(false), 2), resetFileUpload = _z[0], setResetFileUpload = _z[1];
    var _0 = __read(useState({
        isFailed: false,
        isOpen: false,
        msg: "",
    }), 2), serverMsg = _0[0], setServerMsg = _0[1];
    var _1 = __read(React.useState({
        acCode: "",
        relative_NAME: "",
        relation: "",
        panno: "",
        email: "",
        fileName: "",
        loaFiles: null,
        data: "",
        acName: "",
        eqbse: "",
        eqnse: "",
        eqmsei: "",
        fobse: "",
        fonse: "",
        fomsei: "",
        currencybse: "",
        currencynse: "",
        currencymsei: "",
        mcx: "",
        ncdex: "",
        neml: "",
        mobileNo: "",
        databytes: "",
    }), 2), loaFormData = _1[0], setLoaFormData = _1[1];
    var _2 = __read(React.useState(), 2), error = _2[0], setError = _2[1];
    var onHandleChange = function (event) {
        var _a, _b;
        var _c = event.target, name = _c.name, value = _c.value;
        if (name === "panno") {
            setLoaFormData(__assign(__assign({}, loaFormData), (_a = {}, _a[name] = value.toUpperCase(), _a)));
        }
        else {
            setLoaFormData(__assign(__assign({}, loaFormData), (_b = {}, _b[name] = value, _b)));
        }
    };
    var handleFileUpload = function (fileDetails) {
        if (fileDetails && fileDetails.docFile && fileDetails.base64Data) {
            setLoaFormData(__assign(__assign({}, loaFormData), { fileName: fileDetails.docFile, loaFiles: fileDetails.base64Data
                    ? fileDetails.base64Data.split(",")[1]
                    : null }));
        }
    };
    var validationError = function (field, value) {
        var _a;
        setError(__assign(__assign({}, error), (_a = {}, _a[field] = value, _a)));
    };
    var saveLoa = function () {
        di.clients
            .saveLoaDetails(loaFormData)
            .then(function (data) {
            if (data === null || data === void 0 ? void 0 : data.success) {
                setServerMsg({
                    isFailed: false,
                    isOpen: true,
                    msg: "Data saved successfully",
                });
            }
            else {
                setServerMsg({
                    isFailed: true,
                    isOpen: true,
                    msg: "Something went wrong. Please try again",
                });
            }
        })
            .catch(function (error) {
            console.log("error", error);
            setServerMsg({
                isFailed: true,
                isOpen: true,
                msg: "Something went wrong. Please try again",
            });
        });
    };
    var getMasterRelationShipData = function () {
        di.clients
            .getMasterRelation()
            .then(function (val) {
            return setRelationshipList(val === null || val === void 0 ? void 0 : val.map(function (item) {
                return { display: item.valuename, value: item.valueid };
            }));
        })
            .catch(function (error) { return error; });
    };
    var deleteLOA = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, di.clients
                        .deleteLOA({
                        accode: (_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.acCode,
                        acName: (_b = props === null || props === void 0 ? void 0 : props.data) === null || _b === void 0 ? void 0 : _b.acName,
                        companyName: (_c = props === null || props === void 0 ? void 0 : props.data) === null || _c === void 0 ? void 0 : _c.companyName,
                    })
                        .then(function (result) {
                        if (result.success) {
                            setServerMsg({
                                isFailed: false,
                                isOpen: true,
                                msg: "LOA details delete successfully",
                            });
                        }
                        else {
                            setServerMsg({
                                isFailed: true,
                                isOpen: true,
                                msg: "Something went wrong. Please try again",
                            });
                        }
                    })
                        .catch(function (error) {
                        setServerMsg({
                            isFailed: true,
                            isOpen: true,
                            msg: "Something went wrong. Please try again",
                        });
                    })];
                case 1:
                    _d.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    React.useEffect(function () {
        getMasterRelationShipData();
    }, []);
    React.useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
        if (props.data) {
            setLoaFormData({
                acCode: (_a = props.data) === null || _a === void 0 ? void 0 : _a.acCode,
                relative_NAME: ((_b = props.data) === null || _b === void 0 ? void 0 : _b.relative_NAME) || "",
                relation: ((_c = props.data) === null || _c === void 0 ? void 0 : _c.relation) || "",
                panno: ((_d = props.data) === null || _d === void 0 ? void 0 : _d.panno) || "",
                email: ((_e = props.data) === null || _e === void 0 ? void 0 : _e.email) || "",
                fileName: ((_f = props.data) === null || _f === void 0 ? void 0 : _f.fileName) || "",
                loaFiles: null,
                data: ((_g = props.data) === null || _g === void 0 ? void 0 : _g.data) || "",
                acName: ((_h = props.data) === null || _h === void 0 ? void 0 : _h.acName) || "",
                eqbse: ((_j = props.data) === null || _j === void 0 ? void 0 : _j.eqbse) || "False",
                eqnse: ((_k = props.data) === null || _k === void 0 ? void 0 : _k.eqnse) || "False",
                eqmsei: ((_l = props.data) === null || _l === void 0 ? void 0 : _l.eqmsei) || "False",
                fobse: ((_m = props.data) === null || _m === void 0 ? void 0 : _m.fobse) || "False",
                fonse: ((_o = props.data) === null || _o === void 0 ? void 0 : _o.fonse) || "False",
                fomsei: ((_p = props.data) === null || _p === void 0 ? void 0 : _p.fomsei) || "False",
                currencybse: ((_q = props.data) === null || _q === void 0 ? void 0 : _q.currencybse) || "False",
                currencynse: ((_r = props.data) === null || _r === void 0 ? void 0 : _r.currencynse) || "False",
                currencymsei: ((_s = props.data) === null || _s === void 0 ? void 0 : _s.currencymsei) || "False",
                mcx: ((_t = props.data) === null || _t === void 0 ? void 0 : _t.mcx) || "False",
                ncdex: ((_u = props.data) === null || _u === void 0 ? void 0 : _u.ncdex) || "False",
                neml: ((_v = props.data) === null || _v === void 0 ? void 0 : _v.neml) || "False",
                mobileNo: ((_w = props.data) === null || _w === void 0 ? void 0 : _w.mobileNo) || "",
                databytes: ((_x = props.data) === null || _x === void 0 ? void 0 : _x.databytes) || "",
            });
        }
    }, [props.data]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "mx-0 px-0 dpledger-block" },
            React.createElement(Row, { className: "px-0 mx-0" },
                React.createElement(Col, { className: "px-0 HeadRow" },
                    React.createElement("span", { className: "EncodeSansN_20_400 txt" },
                        React.createElement("i", { className: "edel-icon-arrow-left1", onClick: function () {
                                props.setpaymentlinkshow(false);
                            } }),
                        "LOA Details -",
                        React.createElement("span", { className: "EncodeSans_20_700" }, (_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 :
                            _a.acName,
                            ", Accode:", (_b = props === null || props === void 0 ? void 0 : props.data) === null || _b === void 0 ? void 0 :
                            _b.acCode)))),
            React.createElement(Col, { lg: 12, className: "grid-container-4-68 pd-0-30 mt-30" },
                React.createElement("div", null,
                    React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey mgb-5" }, "Category"),
                    React.createElement(InputField, { className: "RobotoM_16_500 txt_blackOne1", placeholderClassName: "", placeholder: "", defaultValue: (_c = props.data) === null || _c === void 0 ? void 0 : _c.companyName, disabled: true })),
                React.createElement("div", null,
                    React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey  mgb-5" }, "Name Of The Family Relative"),
                    React.createElement(InputField, { name: "relative_NAME", className: "RobotoM_16_500 txt_blackOne1", placeholderClassName: "", placeholder: "", defaultValue: loaFormData === null || loaFormData === void 0 ? void 0 : loaFormData.relative_NAME, onChangeEvent: onHandleChange, onBlur: function (error, event) {
                            if (error.required)
                                validationError(event.target.name, "This field is Required");
                            else
                                validationError(event.target.name, "");
                        }, errorText: error === null || error === void 0 ? void 0 : error.relative_NAME, required: true })),
                React.createElement("div", { className: " leadpage-selectdropdown" },
                    React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey  mgb-5" }, "Relation With Account Holder"),
                    React.createElement(SelectDropdown, { placeholder: "Select Relation", id: "financial_dropdown", name: "relation", selected: true, defaultValue: loaFormData === null || loaFormData === void 0 ? void 0 : loaFormData.relation, dropdownOptions: relationshipList, required: true, downarrow: "edel-icon-arrow-down", placeholderClassName: "", onChangeEvent: function (e) {
                            return setLoaFormData(__assign(__assign({}, loaFormData), { relation: e.target.value }));
                        } })),
                React.createElement("div", { className: " leadpage-selectdropdown" },
                    React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey  mgb-5" }, "Pan No"),
                    React.createElement(InputField, { name: "panno", id: "panno", className: "RobotoM_16_500 txt_blackOne1", placeholderClassName: "", pattern: pan, defaultValue: (_d = loaFormData === null || loaFormData === void 0 ? void 0 : loaFormData.panno) === null || _d === void 0 ? void 0 : _d.toUpperCase(), placeholder: "", onChangeEvent: onHandleChange, onBlur: function (error, event) {
                            if (error.required)
                                validationError(event.target.name, "This field is Required");
                            else if (!error.pattern)
                                validationError(event.target.name, "Enter a valid pan");
                            else
                                validationError(event.target.name, "");
                        }, errorText: error === null || error === void 0 ? void 0 : error.panno, required: true }))),
            React.createElement(Col, { lg: 12, className: "grid-container-4-68 pd-0-30 mt-30" },
                React.createElement("div", null,
                    React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey  mgb-5" }, "Mobile No"),
                    React.createElement(InputField, { name: "mobileNo", id: "mobileNo", className: "RobotoM_16_500 txt_blackOne1", placeholderClassName: "", placeholder: "", defaultValue: loaFormData === null || loaFormData === void 0 ? void 0 : loaFormData.mobileNo, pattern: phoneNo, onChangeEvent: onHandleChange, onBlur: function (error, event) {
                            if (!!event.target.value && !error.pattern)
                                validationError(event.target.name, "Enter the correct contact number");
                            else
                                validationError(event.target.name, "");
                        }, errorText: error === null || error === void 0 ? void 0 : error.mobileNo })),
                React.createElement("div", null,
                    React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey mgb-5" }, "Email"),
                    React.createElement(InputField, { name: "email", id: "email", className: "RobotoM_16_500 txt_blackOne1", placeholderClassName: "", placeholder: "", defaultValue: loaFormData === null || loaFormData === void 0 ? void 0 : loaFormData.email, onChangeEvent: onHandleChange, onBlur: function (error, event) {
                            if (!!event.target.value && !error.pattern)
                                validationError(event.target.name, "Enter the correct email id");
                            else
                                validationError(event.target.name, "");
                        }, errorText: error === null || error === void 0 ? void 0 : error.email, pattern: emailRegex }))),
            React.createElement(Col, { lg: 12, className: "pd-0-30 mt-30" },
                React.createElement("table", { className: "table exchange-segment-table" },
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", null, "Exchange Segment"),
                            React.createElement("th", null,
                                React.createElement("div", { className: " flexCenter input-checkbox-row" },
                                    React.createElement("input", { name: "eqse", id: "eqse", type: "checkbox", className: "form-check-input common-checkbox", checked: ((_e = loaFormData === null || loaFormData === void 0 ? void 0 : loaFormData.eqbse) === null || _e === void 0 ? void 0 : _e.toLowerCase()) === "true" &&
                                            ((_f = loaFormData === null || loaFormData === void 0 ? void 0 : loaFormData.fobse) === null || _f === void 0 ? void 0 : _f.toLowerCase()) === "true" &&
                                            ((_g = loaFormData === null || loaFormData === void 0 ? void 0 : loaFormData.currencybse) === null || _g === void 0 ? void 0 : _g.toLowerCase()) === "true", onChange: function (e) {
                                            var _a;
                                            setLoaFormData(__assign(__assign({}, loaFormData), (_a = {}, _a["eqbse"] = e.target.checked.toString(), _a["fobse"] = e.target.checked.toString(), _a["currencybse"] = e.target.checked.toString(), _a)));
                                        } }),
                                    React.createElement("span", { className: "mgl-7" }, " BSE"))),
                            React.createElement("th", null,
                                React.createElement("div", { className: "flexCenter input-checkbox-row" },
                                    React.createElement("input", { type: "checkbox", className: "form-check-input common-checkbox", checked: ((_h = loaFormData === null || loaFormData === void 0 ? void 0 : loaFormData.eqnse) === null || _h === void 0 ? void 0 : _h.toLowerCase()) === "true" &&
                                            ((_j = loaFormData === null || loaFormData === void 0 ? void 0 : loaFormData.fonse) === null || _j === void 0 ? void 0 : _j.toLowerCase()) === "true" &&
                                            ((_k = loaFormData === null || loaFormData === void 0 ? void 0 : loaFormData.currencynse) === null || _k === void 0 ? void 0 : _k.toLowerCase()) === "true", onChange: function (e) {
                                            var _a;
                                            setLoaFormData(__assign(__assign({}, loaFormData), (_a = {}, _a["eqnse"] = e.target.checked.toString(), _a["fonse"] = e.target.checked.toString(), _a["currencynse"] = e.target.checked.toString(), _a)));
                                        } }),
                                    React.createElement("span", { className: "mgl-7" }, "NSE"))),
                            React.createElement("th", null,
                                React.createElement("div", { className: " flexCenter input-checkbox-row" },
                                    React.createElement("input", { type: "checkbox", className: "form-check-input common-checkbox", checked: ((_l = loaFormData === null || loaFormData === void 0 ? void 0 : loaFormData.eqmsei) === null || _l === void 0 ? void 0 : _l.toLowerCase()) === "true" &&
                                            ((_m = loaFormData === null || loaFormData === void 0 ? void 0 : loaFormData.fomsei) === null || _m === void 0 ? void 0 : _m.toLowerCase()) === "true" &&
                                            ((_o = loaFormData === null || loaFormData === void 0 ? void 0 : loaFormData.currencymsei) === null || _o === void 0 ? void 0 : _o.toLowerCase()) === "true", onChange: function (e) {
                                            var _a;
                                            setLoaFormData(__assign(__assign({}, loaFormData), (_a = {}, _a["eqmsei"] = e.target.checked.toString(), _a["fomsei"] = e.target.checked.toString(), _a["currencymsei"] = e.target.checked.toString(), _a)));
                                        } }),
                                    React.createElement("span", { className: "mgl-7" }, " MSEI"))))),
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", null, "Equity"),
                            React.createElement("td", null,
                                React.createElement("input", { type: "checkbox", className: "form-check-input common-checkbox", value: 1, checked: ((_p = loaFormData === null || loaFormData === void 0 ? void 0 : loaFormData.eqbse) === null || _p === void 0 ? void 0 : _p.toLowerCase()) === "true", onChange: function (e) {
                                        var _a;
                                        setLoaFormData(__assign(__assign({}, loaFormData), (_a = {}, _a["eqbse"] = e.target.checked.toString(), _a)));
                                    } })),
                            React.createElement("td", null,
                                React.createElement("input", { type: "checkbox", className: "form-check-input common-checkbox", value: 1, checked: ((_q = loaFormData === null || loaFormData === void 0 ? void 0 : loaFormData.eqnse) === null || _q === void 0 ? void 0 : _q.toLowerCase()) === "true", onChange: function (e) {
                                        var _a;
                                        setLoaFormData(__assign(__assign({}, loaFormData), (_a = {}, _a["eqnse"] = e.target.checked.toString(), _a)));
                                    } })),
                            React.createElement("td", null,
                                React.createElement("input", { type: "checkbox", className: "form-check-input common-checkbox", value: 1, checked: ((_r = loaFormData === null || loaFormData === void 0 ? void 0 : loaFormData.eqmsei) === null || _r === void 0 ? void 0 : _r.toLowerCase()) === "true", onChange: function (e) {
                                        var _a;
                                        setLoaFormData(__assign(__assign({}, loaFormData), (_a = {}, _a["eqmsei"] = e.target.checked.toString(), _a)));
                                    } }))),
                        React.createElement("tr", null,
                            React.createElement("td", null, "F/O"),
                            React.createElement("td", null,
                                React.createElement("input", { type: "checkbox", className: "form-check-input common-checkbox", value: 1, checked: ((_s = loaFormData === null || loaFormData === void 0 ? void 0 : loaFormData.fobse) === null || _s === void 0 ? void 0 : _s.toLowerCase()) === "true", onChange: function (e) {
                                        var _a;
                                        setLoaFormData(__assign(__assign({}, loaFormData), (_a = {}, _a["fobse"] = e.target.checked.toString(), _a)));
                                    } })),
                            React.createElement("td", null,
                                React.createElement("input", { type: "checkbox", className: "form-check-input common-checkbox", value: 1, checked: ((_t = loaFormData === null || loaFormData === void 0 ? void 0 : loaFormData.fonse) === null || _t === void 0 ? void 0 : _t.toLowerCase()) === "true", onChange: function (e) {
                                        var _a;
                                        setLoaFormData(__assign(__assign({}, loaFormData), (_a = {}, _a["fonse"] = e.target.checked.toString(), _a)));
                                    } })),
                            React.createElement("td", null,
                                React.createElement("input", { type: "checkbox", className: "form-check-input common-checkbox", value: 1, checked: ((_u = loaFormData === null || loaFormData === void 0 ? void 0 : loaFormData.fomsei) === null || _u === void 0 ? void 0 : _u.toLowerCase()) === "true", onChange: function (e) {
                                        var _a;
                                        setLoaFormData(__assign(__assign({}, loaFormData), (_a = {}, _a["fomsei"] = e.target.checked.toString(), _a)));
                                    } }))),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Currency"),
                            React.createElement("td", null,
                                React.createElement("input", { type: "checkbox", className: "form-check-input common-checkbox", value: 1, checked: ((_v = loaFormData === null || loaFormData === void 0 ? void 0 : loaFormData.currencybse) === null || _v === void 0 ? void 0 : _v.toLowerCase()) === "true", onChange: function (e) {
                                        var _a;
                                        setLoaFormData(__assign(__assign({}, loaFormData), (_a = {}, _a["currencybse"] = e.target.checked.toString(), _a)));
                                    } })),
                            React.createElement("td", null,
                                React.createElement("input", { type: "checkbox", className: "form-check-input common-checkbox", value: 1, checked: ((_w = loaFormData === null || loaFormData === void 0 ? void 0 : loaFormData.currencynse) === null || _w === void 0 ? void 0 : _w.toLowerCase()) === "true", onChange: function (e) {
                                        var _a;
                                        setLoaFormData(__assign(__assign({}, loaFormData), (_a = {}, _a["currencynse"] = e.target.checked.toString(), _a)));
                                    } })),
                            React.createElement("td", null,
                                React.createElement("input", { type: "checkbox", className: "form-check-input common-checkbox", value: 1, checked: ((_x = loaFormData === null || loaFormData === void 0 ? void 0 : loaFormData.currencymsei) === null || _x === void 0 ? void 0 : _x.toLowerCase()) === "true", onChange: function (e) {
                                        var _a;
                                        setLoaFormData(__assign(__assign({}, loaFormData), (_a = {}, _a["currencymsei"] = e.target.checked.toString(), _a)));
                                    } })))))),
            React.createElement(Col, { lg: 12, className: "grid-container-1 pd-0-30 mt-30 consent-fileupload-section common-fileupload-section" },
                React.createElement("div", null,
                    React.createElement("div", { className: "d-feed-drag" },
                        React.createElement(FileUploadSection, { reset: resetFileUpload, disableCross: false, fileType: ["pdf", "jpg", "svg", "png"], onSubmit: handleFileUpload, fileSize: 8388608 })))),
            serverMsg.isOpen && (React.createElement("div", { className: "d-flex align-item-center justify-content-center p-3" },
                React.createElement("span", { className: "".concat(serverMsg.isFailed ? "text-danger" : "text-success") }, serverMsg.msg))),
            React.createElement("div", { className: "mt-4 col-lg-6 offset-lg-3  justify-content-center" },
                React.createElement("div", { className: "btn-block-loa" },
                    React.createElement("div", { className: "px-0" },
                        React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Save", disabled: (!!error &&
                                Object.keys(error).some(function (val) { return !!error[val]; })) ||
                                !(loaFormData === null || loaFormData === void 0 ? void 0 : loaFormData.panno) ||
                                !(loaFormData === null || loaFormData === void 0 ? void 0 : loaFormData.relative_NAME) ||
                                !(loaFormData === null || loaFormData === void 0 ? void 0 : loaFormData.relation), onClick: function () { return saveLoa(); } })),
                    React.createElement("div", { className: "px-0" },
                        React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Reset", onClick: function () {
                                setLoaFormData(__assign(__assign({}, loaFormData), defaultLoaDetails));
                                setServerMsg({
                                    isFailed: false,
                                    isOpen: false,
                                    msg: "",
                                });
                            } })),
                    React.createElement("div", { className: "px-0" },
                        React.createElement(EdButton, { btnTyp: "midnight-blue-border", type: "button", value: "Delete", onClick: function () { return deleteLOA(); } })))))));
};
export default LoaFormPop;
